import React from 'react';

const Notes = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <title>notes</title>
    <path d="M20.45 3h-17c-1.35 0-2.45 0.95-2.45 2.35v10c0 1.35 1.1 2.65 2.45 2.65h10.8l4.75 3.95v-3.95h1.45c1.35 0 2.55-1.3 2.55-2.65v-10c0-1.4-1.2-2.35-2.55-2.35zM22 15.35c0 0.8-0.75 1.65-1.55 1.65h-2.45v2.75l-3.4-2.75h-11.15c-0.85 0-1.45-0.85-1.45-1.65v-10c0-0.85 0.6-1.35 1.45-1.35h17c0.8 0 1.55 0.5 1.55 1.35v10z"></path>
    <path d="M6 7h12v1h-12v-1z"></path>
    <path d="M6 10h12v1h-12v-1z"></path>
    <path d="M6 13h12v1h-12v-1z"></path>
  </svg>
);

export default Notes;
